import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { NavLink  } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // Importa il plugin AutoTable
import Slide from '../../components/client/SlideActionClient';
import Nav from '../../components/client/NavClient';
import clientService from '../../services/ClientService';
import "../../static/css/datatable.css";

export default function Client({ itemsPerPage = 10 }) {
    const { register, watch, handleSubmit, formState: { errors } } = useForm();
    const [results, setResults] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [itemsPerPageLocal, setItemsPerPageLocal] = useState(itemsPerPage);
    const [isSlideOpen, setIsSlideOpen] = useState(false);
    const [openAction, setOpenAction] = useState(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [client, setClient] = useState({});

    const search = watch("search", ""); // Monitora il campo di ricerca

    const totalPages = Math.ceil(results.length / itemsPerPageLocal);
    // Calcola gli elementi da mostrare nella pagina corrente
    const startIndex = (currentPage - 1) * itemsPerPageLocal;
    const endIndex = startIndex + itemsPerPageLocal;
    const currentItems = results.slice(startIndex, endIndex);
    // Funzione di navigazione
    const goToPage = (page) => {
        setCurrentPage(page);
    };

    const fetchClients= async (search) => {
        try {
            const res = await clientService.getFilter(search);
            // Estrarre i dati specifici dalla struttura complessa di response.data
            const resultsData = res.data || [];
            const total = res.data.length || 0;

            setResults(resultsData); // Salva i risultati
            setTotalResults(total); // Salva il totale dei risultati
            setCurrentPage(1);
            setLoading(false);
            // Calcoliamo dinamicamente itemsPerPageLocal dopo aver ricevuto i dati
            const defaultItemsPerPage = Math.min(itemsPerPage, total);
            setItemsPerPageLocal(defaultItemsPerPage);

        } catch (error) {
            console.error('Error fetching clients', error);
        }
    };

    useEffect(() => {
        fetchClients(search);
    }, [search]);

    // Funzione per aprire/chiudere il pannello laterale
    const toggleSlide = (clientId) => {
        if (clientId) {
            clientService.getClient(clientId)
            .then((res) => {
                setClient(res.data);
            }).catch((error) => {
                console.error("Error get client: ", error);
            });
        } else {
            setClient(
                Object.keys(client || {}).reduce((acc, key) => {
                    acc[key] = ""; // Imposta tutti i campi a stringa vuota
                    return acc;
                }, {})
            );
         }

        setIsSlideOpen(!isSlideOpen);
    };
    // Funzione per gestire l'apertura e la posizione del sottomenu azione
    const handleActionClick = (index,e) => {
        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;
        const adjustedX = offsetX - 80;
        const adjustedY = offsetY - 10;

        setPosition((prevPositions) => ({
              ...prevPositions,
              [index]: { x: adjustedX, y: adjustedY }, // Imposta la posizione dell'elemento
            }));
        setOpenAction(openAction === index ? null : index);
    };
    // Funzione per aggiornare il numero di elementi per pagina
    const handleItemsPerPageChange = (event) => {
        setItemsPerPageLocal(parseInt(event.target.value, 10));
        setCurrentPage(1);
    };
    // Funzione per generare le opzioni dinamiche per la select
    const generateItemsPerPageOptions = () => {
        const options = [];
        const maxItems = totalResults;

        if (maxItems <= 2) {
          options.push(2);
        } else if (20 <= maxItems && maxItems <= 50){
          options.push(10, 25, maxItems);
        } else if (maxItems > 50) {
            options.push(10, 25, 50);
        } else {
            // Aggiungiamo anche multipli di 2 tra il minimo e il massimo
            for (let i = 2; i <= maxItems; i *= 2) {
                if (i < maxItems) options.push(i);
            }
            // Se il numero totale è abbastanza grande, aggiungiamo anche il numero massimo
            if (maxItems > 2) options.push(maxItems);
        }

        return options;
    };

    const getFormattedDate = () => {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${day}-${month}-${year}`;
    };

    const handleExportPDF = () => {
        const doc = new jsPDF('l', 'mm', 'a4');//configuro con l(stampa orizzontale)
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(12);
        doc.text("Lista Clienti", 14, 10); //Titolo
        doc.autoTable({
            head: [['NR','Azienda','Contatti','Dati Fiscali','Note']], // Intestazioni della tabella
            body: results.map((cliente, index) => [index + 1,`${cliente.fullname}\n${cliente.indirizzo_sede}\n${cliente.comune} ${cliente.provincia}\n${cliente.cap} ${cliente.nazione}`,
                `Telefono: ${cliente.phone}\nPec: ${cliente.email_pec}\nEmail: ${cliente.email}`,
                `P.Iva: ${cliente.piva}\nSdi: ${cliente.identificativo}\nIban: ${cliente.iban}`,
                 cliente.note]), // Corpo della tabella
            startY: 20, // Imposta la posizione di inizio della tabella
            theme: 'grid', // Aggiungi griglia alla tabella
        });
        doc.save(`clienti_${getFormattedDate()}.pdf`);
    };

  	return (
  	<>
  	    <div className="row">
            <div className="col-md-12">
                {/* Nav Client */}
                <Nav />
            </div>
        </div>
  	    <div className="card">
            {/* List Clienti */}
            <div className="card-datatable table-responsive">
                <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                    <div className="row">
                        <div className="col-md-2">
                            <div className="dataTables_length">
                                <label>
                                    <select name="DataTables_Table_0_length" className="form-select" id="itemsPerPage"
                                        value={itemsPerPageLocal} onChange={handleItemsPerPageChange}>
                                        {generateItemsPerPageOptions().map((value) => (
                                            <option key={value} value={value}>{value}</option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-10">
                            <div className="dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-end flex-md-row flex-column mb-6 mb-md-0 mt-n6 mt-md-0">
                                <div className="dataTables_filter">
                                    <label>
                                        <input className="form-control" type="text"
                                            placeholder="Cerca per nome..."
                                            {...register('search')}
                                        />
                                    </label>
                                </div>
                                <div className="dt-buttons btn-group flex-wrap">
                                    <div className="btn-group">
                                        <button onClick={handleExportPDF}  className="btn buttons-collection dropdown-toggle btn-label-secondary mx-4" type="button" >
                                            <span><i className="bx bx-export me-2 bx-sm"></i>Export</span>
                                        </button>
                                    </div>
                                    {/* Pulsante per aprire il modulo di aggiunta cliente */}
                                    <button className="btn add-new btn-primary" onClick={() => toggleSlide(null)}>
                                         <span>
                                            <i className="bx bx-plus bx-sm me-0 me-sm-2"></i>
                                            <span className="d-none d-sm-inline-block">Aggiungi Cliente</span>
                                         </span>
                                   </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table className="datatables-users table border-top dataTable no-footer dtr-column">
                        <thead>
                            <tr>
                                <th>P.IVA</th>
                                <th>RAGIONE SOCIALE</th>
                                <th>EMAIL</th>
                                <th>TELEFONO</th>
                            </tr>
                        </thead>
                        {loading && (
                            <tbody>
                                <tr className="odd">
                                    <td className="dataTables_empty">Loading...</td>
                                </tr>
                            </tbody>
                        )}
                        <tbody>
                            {currentItems.map((result,index) => (
                                <tr key={result.id_client}>
                                    <td>{result.piva}</td>
                                    <td>{result.fullname}</td>
                                    <td>{result.email}</td>
                                    <td>{result.phone}</td>
                                    <td>
                                        <div className="dropdown">
                                            <button type="button" className="btn p-0" onClick={(e) => handleActionClick(index,e)}>
                                                <i className="bx bx-dots-vertical-rounded"></i>
                                            </button>
                                            <div className={`dropdown-menu ${openAction === index ? "show-action" : ""}`}
                                                style={{
                                                    position: 'absolute',
                                                    transform: position[index]
                                                        ? `translate3d(${position[index].x}px, ${position[index].y}px, 0px)`
                                                        : 'translate3d(0px, 0px, 0px)',
                                                    transition: 'transform 0.3s ease',
                                                }}
                                            >
                                                <NavLink to={`/client-detail/${result.id_client}`} className="dropdown-item">
                                                    <i className="bx bx-show me-1"></i>Visualizza
                                                </NavLink>
                                                <a className="dropdown-item" onClick={() => toggleSlide(result.id_client)}>
                                                    <i className="bx bx-edit-alt me-1"></i>Modifica
                                                </a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                         </tbody>
                    </table>
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <div className="dataTables_info" role="status" aria-live="polite">
                                Risultati ottenuti : {totalResults}
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <div className="dataTables_paginate paging_simple_numbers custom-ryo">
                                {!loading && (
                                    <div className="pagination">
                                        <button className="page-link" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                                            <i className="bx bx-chevron-left bx-18px"></i>
                                        </button>
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <button
                                              key={index + 1}
                                              onClick={() => goToPage(index + 1)}
                                              disabled={currentPage === index + 1}
                                              className={`page-link ${currentPage === index + 1  ? "current-page" : ""}`}
                                            >
                                              {index + 1}
                                            </button>
                                        ))}
                                        <button className="page-link" onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
                                            <i className="bx bx-chevron-right bx-18px"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Slide */}
            <Slide show={isSlideOpen} onClose={toggleSlide} onFetchClients={fetchClients} search={search} client={client}/>
            {/* Slide */}
            {/* /List Clienti*/}
  	    </div>
    </>
	);
}